<div class="container">
  <div class="container__content">
    <h1>
      <i class="bi bi-sign-dead-end"></i>
    </h1>
    <div class="container__content__text">
      <h2>{{ "GLOBAL.PAGE_NOT_FOUND.TITLE" | translate }}</h2>
      <span>{{ "GLOBAL.PAGE_NOT_FOUND.TEXT" | translate }}</span>
    </div>
  </div>
</div>
